export * from './error.service'
export * from './error-type.enum';
export * from './eval-error';
export * from './uri-error';
export * from './type-error';

export interface ExError extends Error {
    name:string;
    message:string;    
}



// WEBPACK FOOTER //
// ./src/app/error/error.ts